const removeValidationTooltip = (element, config) => {
    // to remove tooltip just pass tooltip css class name
    if (!(config && config.toolTipCss) || !element) {
        return;
    }
    element.querySelector(`span.${config.toolTipCss}_text`)?.remove();
    element.classList?.remove(config.toolTipCss);
    return element;
}
export default removeValidationTooltip;